import { defineComponent as _defineComponent } from 'vue'
import { ClockIcon, XIcon } from '@heroicons/vue/solid';

interface TemporalConflict {
    questionPeriod: string;
    filterPeriod: string;
    details?: string;
    suggestedDateFrom?: string;
    suggestedDateTo?: string;
}

interface Props {
    conflict: TemporalConflict;
    dismissible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TemporalWarning',
  props: {
    conflict: { type: Object, required: true },
    dismissible: { type: Boolean, required: false, default: true }
  },
  emits: ["auto-correct", "manual-edit", "proceed", "rephrase", "dismiss"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const onAutoCorrect = () => emit('auto-correct');
const onManualEdit = () => emit('manual-edit');
const onProceed = () => emit('proceed');
const onRephrase = () => emit('rephrase');
const onDismiss = () => emit('dismiss');

const RELATIVE_PERIOD_LABELS: Record<string, string> = {
    today: 'hoje',
    yesterday: 'ontem',
    day_before_yesterday: 'anteontem',
};

function formatDate(dateString: string): string {
    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) {
        return dateString;
    }

    return parsed.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
}

function formatDateTimeRange(value: string): string {
    const parts = value.split(' - ').map((item) => item.trim());
    if (parts.length === 2) {
        return `${formatDate(parts[0])} a ${formatDate(parts[1])}`;
    }

    const isoRange = value.split(' to ').map((item) => item.trim());
    if (isoRange.length === 2) {
        return `${formatDate(isoRange[0])} a ${formatDate(isoRange[1])}`;
    }

    return formatDate(value);
}

function formatQuestionPeriod(value: string): string {
    const normalized = String(value || '')
        .trim()
        .toLowerCase();
    if (!normalized) {
        return '-';
    }

    if (RELATIVE_PERIOD_LABELS[normalized]) {
        return RELATIVE_PERIOD_LABELS[normalized];
    }

    return formatDateTimeRange(value);
}

function formatFilterPeriod(value: string): string {
    if (!value) {
        return '-';
    }

    return formatDateTimeRange(value);
}

const __returned__ = { emit, onAutoCorrect, onManualEdit, onProceed, onRephrase, onDismiss, RELATIVE_PERIOD_LABELS, formatDate, formatDateTimeRange, formatQuestionPeriod, formatFilterPeriod, get ClockIcon() { return ClockIcon }, get XIcon() { return XIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})